let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9C3Le")).then(() => parcelRequire('hl6ow'));